import { siteStats } from "@/mocks/gua";

interface HeroProps {
  onSearch: (q: string) => void;
}

export default function Hero({ onSearch }: HeroProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const input = form.elements.namedItem("kw") as HTMLInputElement;
    onSearch(input.value.trim());
    document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative w-full overflow-hidden" aria-label="大瓜网首屏">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20playful%20abstract%20watermelon%20and%20melon%20illustration%20scene%2C%20vivid%20coral%20red%20and%20cream%20and%20soft%20sage%20green%20color%20palette%2C%20soft%20gradient%20background%2C%20minimal%20flat%20illustration%20style%2C%20light%20and%20airy%2C%20modern%20editorial%20poster%20feel%2C%20high%20detail%2C%20no%20text&width=1920&height=1080&seq=hero-gua-01&orientation=landscape"
        alt="大瓜网暖色抽象西瓜插画背景"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/60 to-background-50" />

      <div className="relative mx-auto w-full max-w-7xl px-4 pb-14 pt-36 md:px-6 md:pt-44">
        <div className="mx-auto flex max-w-3xl w-full flex-col items-center text-center">
          <span className="mb-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-200 bg-accent-100 px-4 py-1.5 text-xs font-semibold text-accent-800 md:text-sm">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-pingSoft rounded-full bg-accent-500" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            全网热瓜 · 实时围观现场
          </span>

          <h1 className="font-heading text-3xl font-extrabold leading-tight tracking-tight text-foreground-950 md:text-5xl">
            全网大瓜，一块儿
            <span className="text-primary-500">吃明白</span>
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            评论区热议、围观现场、吃瓜群众观点实时汇聚。热帖精选、话题互动，看瓜也看人，各路看法都在这里碰撞。
          </p>

          <form
            onSubmit={handleSubmit}
            className="mt-8 flex w-full max-w-xl items-center gap-2 rounded-full border border-background-200 bg-background-50 p-1.5 shadow-soft"
            role="search"
            aria-label="搜索热门话题"
          >
            <i className="ri-search-line pl-3 text-lg text-foreground-400" aria-hidden="true" />
            <input
              type="text"
              name="kw"
              className="w-full min-w-0 flex-1 bg-transparent px-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              placeholder="搜搜正在热议的话题，比如：长风渡口"
              aria-label="搜索关键词"
            />
            <button
              type="submit"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              去围观
            </button>
          </form>

          <dl className="mt-10 grid w-full max-w-2xl grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
            {siteStats.map((s) => (
              <div
                key={s.label}
                className="rounded-2xl border border-background-200 bg-background-50/70 px-3 py-4 backdrop-blur-sm"
              >
                <dt className="sr-only">{s.label}</dt>
                <dd className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
                  {s.value}
                </dd>
                <dd className="mt-1 text-xs text-foreground-500 md:text-sm">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}